import { render } from "./EventSite.vue?vue&type=template&id=05b531ce&scoped=true"
import script from "./EventSite.vue?vue&type=script&lang=js"
export * from "./EventSite.vue?vue&type=script&lang=js"

import "./EventSite.vue?vue&type=style&index=0&id=05b531ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b531ce"]])

export default __exports__